import { render, staticRenderFns } from "./ReceivedMessages.vue?vue&type=template&id=4aeec7c2&"
import script from "./ReceivedMessages.vue?vue&type=script&lang=js&"
export * from "./ReceivedMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports